// extracted by mini-css-extract-plugin
export default {"switch":"checkbox_switch__dvEZP","slider":"checkbox_slider__rAozA"};